import React from 'react';
import {MarkColor} from './Styles';

const GroupByAggregateViewLegend = props => {
    return (
        <div className="flex flexCentre margin-t--l">
            <div className='flex flexColumn padding--l margin-b--l ch-emph-block'>
                <div className='flex flexCentre margin-b--l'>
                    <h4>Key</h4>
                </div>
                <div className='flex flexCentre flexAlignCentre flexSpaceBetween' style={{lineHeight: '26px'}}>
                    <div className='flex margin-r--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l' style={{
                            backgroundColor: MarkColor.mark0to29,
                            color: '#fff',
                            height: '26px',
                            width: '48px'
                        }}></div>
                        0% - 25%
                    </div>
                    <div className='flex margin-r--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l' style={{
                            backgroundColor: MarkColor.mark30to59,
                            color: '#fff',
                            height: '26px',
                            width: '48px'
                        }}></div>
                        26% - 50%
                    </div>
                    <div className='flex margin-r--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l' style={{
                            backgroundColor: MarkColor.mark60to79,
                            color: '#fff',
                            height: '26px',
                            width: '48px'
                        }}></div>
                        51% - 75%
                    </div>
                    <div className='flex margin-r--xl'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l' style={{
                            backgroundColor: MarkColor.mark80to100,
                            color: '#fff',
                            height: '26px',
                            width: '48px'
                        }}></div>
                        76% - 100%
                    </div>
                    <div className='flex'>
                        <div className='flex flexCentre flexAlignCentre margin-r--l' style={{
                            backgroundColor: MarkColor.SKIPPED,
                            color: '#fff',
                            height: '26px',
                            width: '48px'
                        }}></div>
                        Not completed
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GroupByAggregateViewLegend;